import HomeNavBar from "@/components/HomeNavBar/HomeNavBar.vue";

export default {
    components: {
        HomeNavBar,
    }

}